var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"bubble-message",class:_vm.mountClass,style:(_vm.styles)},[_vm._t("default"),_c('div',{staticClass:"pointer",style:(_vm.pointerStyle)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }